import { useQuery } from '@tanstack/react-query';
import { DashboardShell } from '@/components/layout/DashboardShell';
import { BestTeachersWidget } from '@/components/admin/reports/BestTeachersWidget';
import { WorstTeachersWidget } from '@/components/admin/reports/WorstTeachersWidget';
import { TeacherStatsWidget } from '@/components/admin/reports/TeacherStatsWidget';
import { AttendanceTrendGraph } from '@/components/admin/reports/AttendanceTrendGraph';
import { PersonReportPicker } from '@/components/admin/reports/PersonReportPicker';
import TeacherReportGenerator from '@/components/admin/reports/TeacherReportGenerator';
import { adminService } from '@/services/admin';

export default function AdminReportsTeachersPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['teacher-attendance-trend', 8],
    queryFn: () => adminService.getTeacherAttendanceTrend({ months: 8 }),
  });

  return (
    <DashboardShell title="Teachers Reports" role="admin">
      <div className="space-y-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <BestTeachersWidget />
          <WorstTeachersWidget />
        </div>
        <TeacherStatsWidget />
        <AttendanceTrendGraph
          title="Teacher attendance over time"
          caption="Active staff. Present, absent, and rate."
          data={data?.months}
          isLoading={isLoading}
        />
        <PersonReportPicker kind="teacher" />
        <TeacherReportGenerator />
      </div>
    </DashboardShell>
  );
}
